export enum Lengths {
  EMAIL = 256,
  PHONE = 32,
  NUMBER = 15,
  DESCRIPTION = 256,
  NAME = 26,
  LONG = 1024,
  VERY_LONG = 1024 * 5,
  MIN_3 = 3,
}
